import React, { Component } from 'react';
import Home from './home.js'
import { HashRouter, Route, Link } from "react-router-dom";
import './App.css';


import Episodes from "./episode";
import Episode1 from "./Episodes/Episode1";
import Episode2 from "./Episodes/Episode2";
import Episode3 from "./Episodes/Episode3";
import Episode4 from "./Episodes/Episode4";
import Episode5 from "./Episodes/Episode5";
import Episode6 from "./Episodes/Episode6";
import Episode7 from "./Episodes/Episode7";
import Episode8 from "./Episodes/Episode8";
import Episode9 from "./Episodes/Episode9";
import Episode10 from "./Episodes/Episode10";
import Episode11 from "./Episodes/Episode11";
import Episode12 from "./Episodes/Episode12";
import Episode13 from "./Episodes/Episode13";
import Episode14 from "./Episodes/Episode14";
import Episode15 from "./Episodes/Episode15";
import Episode16 from "./Episodes/Episode16";
import Episode17 from "./Episodes/Episode17";
import Episode18 from "./Episodes/Episode18";
import Episode19 from "./Episodes/Episode19";
import Episode20 from "./Episodes/Episode20";
import Episode21 from "./Episodes/Episode21";
import Episode22 from "./Episodes/Episode22";
import Episode23 from "./Episodes/Episode23";
import Episode24 from "./Episodes/Episode24";
import Episode25 from "./Episodes/Episode25";
import Episode26 from "./Episodes/Episode26";
import Episode27 from "./Episodes/Episode27";
import Episode28 from "./Episodes/Episode28";
import Episode29 from "./Episodes/Episode29";
import Episode30 from "./Episodes/Episode30";
import SpecialEpisode1 from "./Episodes/SpecialEpisode1";
import SpecialEpisode2 from "./Episodes/SpecialEpisode2";
import SpecialEpisode3 from "./Episodes/SpecialEpisode3";
import S2Episode1 from "./Episodes/S2Episode1";
import S2Episode2 from "./Episodes/S2Episode2";
import S2Episode3 from "./Episodes/S2Episode3";
import S2Episode4 from "./Episodes/S2Episode4";
import S2Episode5 from "./Episodes/S2Episode5";
import S2Episode6 from "./Episodes/S2Episode6";
import S2Episode7 from "./Episodes/S2Episode7";
import S2Episode8 from "./Episodes/S2Episode8";
import S2Episode9 from "./Episodes/S2Episode9";
import S2Episode10 from "./Episodes/S2Episode10";
import SquidGame from "./Episodes/SquidGame";
import SpecialEpisode4 from "./Episodes/SpecialEpisode4";
import SpecialEpisode5 from "./Episodes/SpecialEpisode5";
import SpecialEpisode6 from "./Episodes/SpecialEpisode6";


  class App extends Component {
    render() {
      return (
       <HashRouter basename='/'>
          <Route exact path="/" component={Home} />
          <Route path="/episodes" component={Episodes} />
          <Route path="/Episode1" component={Episode1} />
          <Route path="/Episode2" component={Episode2} />
          <Route path='/Episode3' component={Episode3}></Route>
          <Route path='/Episode4' component={Episode4}></Route>
          <Route path='/Episode5' component={Episode5}></Route>
          <Route path='/Episode6' component={Episode6}></Route>
          <Route path='/Episode7' component={Episode7}></Route>
          <Route path='/Episode8' component={Episode8}></Route>
          <Route path='/Episode9' component={Episode9}></Route>
          <Route path='/Episode10' component={Episode10}></Route>
          <Route path='/Episode11' component={Episode11}></Route>
          <Route path='/Episode12' component={Episode12}></Route>
          <Route path='/Episode13' component={Episode13}></Route>
          <Route path='/Episode14' component={Episode14}></Route>
          <Route path='/Episode15' component={Episode15}></Route>
          <Route path='/Episode16' component={Episode16}></Route>
          <Route path='/Episode17' component={Episode17}></Route>
          <Route path='/Episode18' component={Episode18}></Route>
          <Route path='/Episode19' component={Episode19}></Route>
          <Route path='/Episode20' component={Episode20}></Route>
          <Route path='/Episode21' component={Episode21}></Route>
          <Route path='/Episode22' component={Episode22}></Route>
          <Route path='/Episode23' component={Episode23}></Route>
          <Route path='/Episode24' component={Episode24}></Route>
          <Route path='/Episode25' component={Episode25}></Route>
          <Route path='/Episode26' component={Episode26}></Route>
          <Route path='/Episode27' component={Episode27}></Route>
          <Route path='/Episode28' component={Episode28}></Route>
          <Route path='/Episode29' component={Episode29}></Route>
          <Route path='/Episode30' component={Episode30}></Route>
          <Route path='/SpecialEpisode1' component={SpecialEpisode1}></Route>
          <Route path='/SpecialEpisode2' component={SpecialEpisode2}></Route>
          <Route path='/SpecialEpisode3' component={SpecialEpisode3}></Route>
          <Route path='/S2Episode1' component={S2Episode1}></Route>
          <Route path='/S2Episode2' component={S2Episode2}></Route>
          <Route path='/S2Episode3' component={S2Episode3}></Route>
          <Route path='/S2Episode4' component={S2Episode4}></Route>
          <Route path='/S2Episode5' component={S2Episode5}></Route>
          <Route path='/S2Episode6' component={S2Episode6}></Route>
          <Route path='/S2Episode7' component={S2Episode7}></Route>
          <Route path='/S2Episode8' component={S2Episode8}></Route>
          <Route path='/S2Episode9' component={S2Episode9}></Route>
          <Route path='/S2Episode10' component={S2Episode10}></Route>
          <Route path='/SquidGame' component={SquidGame}></Route>
          <Route path='/SpecialEpisode4' component={SpecialEpisode4}></Route>
          <Route path='/SpecialEpisode5' component={SpecialEpisode5}></Route>
          <Route path='/SpecialEpisode6' component={SpecialEpisode6}></Route>
       </HashRouter>
      );
     }
  }

const HomeAppjs = () => <div><Home></Home></div>
  
export default App; 

